export default {
  Options: {
    FollowingSubBudgetItem: 'Lấy diễn giải theo tiểu mục',
    FollowingOrgVoucher: 'Lấy diễn giải theo chứng từ gốc',
    HideFormNextTime: 'Không hiển thị thông tin này lần sau',
  },

  Description: {
    GenerateExpenseAccountingFromBUTransfer: 'Hạch toán chi phí lương, bảo hiểm sinh ra từ Chuyển khoản kho bạc số {0}',
    GenerateExpenseAccountingFromBUTreasuryWithdrawal:
      'Hạch toán chi phí lương, bảo hiểm sinh ra từ Phiếu rút tiền kho bạc số {0}',
    GenerateExpenseAccountingFromCAPayment: 'Hạch toán chi phí lương, bảo hiểm sinh ra từ Phiếu chi số {0}',
    GenerateExpenseAccountingFromBAWithDraw: 'Hạch toán chi phí lương, bảo hiểm sinh ra từ Phiếu chi tiền gửi số {0}',
    GenerateExpenseAccountingFromBUTransferDeposit:
      'Hạch toán chi phí lương, bảo hiểm sinh ra từ Chuyển khoản kho bạc vào tài khoản tiền gửi số {0}',
    GenerateCAPaymentFromBUTreasuryWithdrawal: 'Phiếu chi trả lương sinh ra từ Phiếu rút tiền kho bạc số {0}',
    GenerateBAWithDrawFromBUTransferDeposit:
      'Phiếu chi tiền gửi trả lương sinh ra từ Chuyển khoản kho bạc vào tài khoản tiền gửi số {0}',
  },

  Messages: {
    GenerateExpenseAccountingQuestion:
      'Bạn có muốn sinh chứng từ hạch toán chi phí lương, bảo hiểm, kinh phí công đoàn?',
    CheckAccountingCreated:
      'Đã sinh chứng từ Hạch toán chi phí lương, bảo hiểm số <span class="customCallBack" style="color: #0078d7;cursor:pointer;">{0}</span>. Bạn có muốn xem chứng từ này không?',
  },

  Titles: {
    CheckAccountingCreated: 'Sinh chứng từ Hạch toán chi phí lương, bảo hiểm, KPCĐ',
  },

  ButtonUtil: {
    GenerateExpenseAccounting: 'GenerateExpenseAccounting',
    GenerateSalaryPayment: 'GenerateSalaryPayment',
    GenNewVoucherFromCurVoucher: 'GenNewVoucherFromCurVoucher',
  },

  WarningText: {
    MissAccountingSalaryText: 'Bạn chưa hạch toán chi phí lương. Vui lòng thực hiện ngay',
    MissSalaryExpenseText: 'Bạn chưa sinh chứng từ trả lương. Vui lòng thực hiện ngay',
  },
};
